import useApi from "./useApiRequest";
import { useMutation } from "react-query";

export const CreateHistorico = ()  => {
    const api = useApi();

    const mutate = async (params) => {
        const data  = await api.post(`/historico`, params, {
            dataType: "json",
            hasFormData: false,
            hasCustomUrl: false,
        });
        return data.data;
    };

    const mutation = useMutation(mutate);

    return {
        createHistoricoMutation: mutation.mutate,
    };
}